import {React,useState,useEffect} from "react";
import authStorage from "../../utils/authStorage";
import {useParams, Link,useNavigate,useLocation} from "react-router-dom";
import searchIcon from "../../assets/images/searchIcon.svg";
import bellIcon from "../../assets/images/bellIcon.svg";
import adminDumny from "../../assets/images/adminDumny.svg";
import { BASE_URL } from "../../config"
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import{
    ArrowRightOnRectangleIcon, UserIcon
    
} from "@heroicons/react/24/solid"

const Navbar = ({ parentToChild,name,navValue }) => {
    const [contantName,setContantName]=useState();
    const[userName,setUserName]=useState();
    const [role,setRole]=useState();
    const [isActive, setIsActive] = useState(false);
    // const lastPage=open;
    const [isProfile, setIsProfile] = useState();
    const navigate=useNavigate();
    const handleBoxClick = () => {
      setIsActive(!isActive);
    };
    const functionCall=()=>{
        navValue(1);
    
    }

    const fetchProfileImage = () => {
        axios({
          headers: {
            "x-access-token": authStorage.getItem("auth-token"),
          },
          url: `${BASE_URL}/user/profile/image`,
          method: 'GET',
          responseType: 'blob'
        }).then((res) => {
          const url = URL.createObjectURL(res.data);
          
          setIsProfile(url)
        }).catch((err) => {
          if (err?.response?.data?.message) {
            // setError(err?.response?.data?.message);
         console.log("error are in backend");
          }
        });
      };

    const params = useParams();
      const authenticateFitbit = () => {
        axios({
            headers: {
                "x-access-token": authStorage.getItem("auth-token")
            },
            url: `${BASE_URL}/auth/updateFitBitToken`, //your url
            method: 'PUT',
            data: { fitBitUserID: params?.fitbit_user_id }
        }).then((res) => {
            axios({
                headers: {
                    "x-access-token": authStorage.getItem("auth-token")
                },
                url: `${BASE_URL}/auth/fitBitRefreshToken`, //your url
                method: 'GET'
            }).then((res) => {
                console.log(res, '+++++++++++++++++++++');
            });
            //navigate('/device');
            //window.location = window.location.origin + '/device';

            console.log("pathname : ", window.location.pathname);
            
            // Path check before redirect
            if (window.location.pathname === "/Managed/MamberhipMobileApp") {
                window.location = window.location.origin + '/Managed/MamberhipMobileApp';
            } 
            else if(window.location.pathname === "/payment-app-confirm"){
                window.location = window.location.origin + '/payment-app-confirm';
            } 
            else if(window.location.pathname === "/personalAppTraining"){
                window.location = window.location.origin + '/personalAppTraining';
            } 
            else if(window.location.pathname === "/training-payment-app-confirm"){
                window.location = window.location.origin + '/training-payment-app-confirm';
            } else {
                window.location = window.location.origin + '/device';
            }

            return false;
        });
    };

    const token = authStorage.getItem("auth-token");
    const impersonatedUserName = authStorage.getItem("user-name");
    let isImpersonating = false;
    try {
        if (token) {
            const decoded = jwtDecode(token);
            isImpersonating = decoded.isImpersonating || false;
        }
    } catch (err) {
        console.error("Invalid token");
    }

    const exitImpersonation = async () => {
        try {
            const res = await axios({
                url: `${BASE_URL}/auth/impersonate/exit`,
                method: "POST",
                headers: {
                    "x-access-token": authStorage.getItem("auth-token"),
                },
            });

            const data = res?.data?.data;

            // Restore admin data exactly like normal login
            authStorage.setItem("auth-token", data?.accessToken);
            authStorage.setItem(
                "walkthrough",
                JSON.stringify({
                    walkThroughPending: data?.walkThroughPending,
                    walkThroughSteps: data?.walkThroughSteps,
                })
            );
            authStorage.setItem(
                "company",
                data?.company ? JSON.stringify(data?.company) : ""
            );
            authStorage.setItem(
                "user",
                JSON.stringify({
                    price: data?.price,
                    userCount: data?.userCount,
                    userRange: data?.userRange,
                    expectedCftUser: data?.expectedCftUser,
                })
            );
            authStorage.setItem("roles", data?.roles);
            authStorage.setItem(
                "user-name",
                (data?.firstName || "") + " " + (data?.lastName || "")
            );
            authStorage.setItem("email", data?.email);
            authStorage.setItem("subscribedStatus", data?.subscribedStatus || false);
            authStorage.setItem("planType", data?.planType || "");
            authStorage.setItem("coupon", data?.coupon || "");
            authStorage.setItem("status", data?.status || "");

            authStorage.removeItem("adminToken");

            window.location.href = "/users";
        } catch (err) {
            console.error(err);
            alert("Failed to exit impersonation");
        }
    };
    
    useEffect(()=>{
        setContantName(name);
        fetchProfileImage();

        if(name.includes("device/authenticate")){
            setContantName("Authenticating...");
            authenticateFitbit();
            console.log("function call 2 ")
        }
        
    },[name]);
    useEffect(()=>{
        setUserName(authStorage.getItem('user-name'))
        setRole(authStorage.getItem('roles'));
        fetchProfileImage();
    },[])
    useEffect(()=>{
        console.log("function call ")
        setUserName(authStorage.getItem('user-name'))
        setRole(authStorage.getItem('roles'));
        fetchProfileImage();
    },[isActive])
    return (
      
        <div className="top-header">
            <div className="top-header-inner">
                <div>
                    <span className="hamberger" onClick={parentToChild}>
                        <span />
                    </span>
                    <h2 className="font-xl">{contantName}</h2>
                </div>
                <div className="right-box">
                    {/* <div className="search-box">
                        <img src={searchIcon} alt="Icon" />
                        <input type="search" placeholder="Search Here" />
                    </div>
                    <div className="notification-box">
                        <img src={bellIcon} alt="Icon" />
                        <div className="live" />
                    </div> */}
                    {isImpersonating ? (
                        <div className="fixed top-4 right-4 z-50 flex items-center bg-yellow-100 border-l-4 border-yellow-500 text-yellow-800 px-4 py-2 shadow-md rounded-md space-x-3">
  <span className="font-semibold">
    Impersonating User {impersonatedUserName ? `(as ${impersonatedUserName})` : ""}
  </span>
  {/*
  <button
    onClick={exitImpersonation}
    className="text-yellow-700 bg-yellow-200 hover:bg-yellow-300 hover:text-yellow-900 px-3 py-1 rounded transition duration-200 ease-in-out"
  >
    Exit
  </button>
  */}
</div>
                    ) : (
                        <div className="admin-box" onClick={handleBoxClick}>
                        <img src={isProfile ? `${isProfile}` : adminDumny} alt="Admin" />
                        <div>
                            <div className="name w-32 whitespace-nowrap overflow-hidden text-ellipsis ...">{userName}</div>
                            <div className="title">{role}</div>
                        </div>

                        <div className={`admin-popup ${isActive ? "active" : ""}`}>
                            <ul>
                            <li style={{ margin: "20px" }} onClick={functionCall}>
                                <UserIcon className="h-6 text-gray-500" /> My Profile
                            </li>
                            <li
                                style={{ margin: "20px" }}
                                onClick={() => {
                                navigate("/");
                                authStorage.clear();
                                }}
                            >
                                <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-5 w-5"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                                >
                                <path
                                    fillRule="evenodd"
                                    d="M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z"
                                    clipRule="evenodd"
                                />
                                </svg>
                                Logout
                            </li>
                            </ul>
                        </div>
                        </div>
                    )}

                </div>
            </div>
        </div>
    );
};

export default Navbar;
